var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ImagesGallery',{attrs:{"images":_vm.bridge.BridgePhotos,"parent-id":_vm.bridge.id,"file-type":"bridge_photo","edit":true},on:{"update":function($event){return _vm.$emit('updateBridge')}}})}
var staticRenderFns = []

export { render, staticRenderFns }